<template>
    <cr-radio v-model="model" required :name="t('CHALLENGE_FORM_DEFAULT_LABEL')" tag="fieldset">
        <legend class="cr-mb4"> {{ challenge.description }} </legend>
        <cr-radio-item v-for="choice in challenge.choice.values" :key="choice.id" :value="choice.id" class="cr-mb2">
            {{ choice.text }}
        </cr-radio-item>
    </cr-radio>
</template>
<style scoped>
:deep(.cr-radio-label)
{
    font-size: var(--cr-input-text-size);
}
legend::before
{
    /* No asterisk. Required nature of questions included in intro dialog. */
    content: none !important; 
}
.cr-radio-item :deep(input:checked)
{
    border-color: var(--cr-text);
}
.cr-radio-item :deep(input:focus-visible)
{
    border-color: var(--cr-black);
}
</style>

<script setup lang="ts">
import { IChallenge } from '@cyber-range/cyber-range-api-ctf-challenge-client';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps<{
    challenge: IChallenge; 
    disabled?: boolean; 
}>();

const model = defineModel<string>();
</script>